import Vue from 'vue'
import directives from '@/directives'

Vue.use(directives)

